import type { Textschluessel } from './i18n'
import { useT } from './i18n'

/**
 * Die Länder, in die bestellt werden kann.
 *
 * An einer Stelle, weil zwei sie brauchen: die Kasse für ihr Auswahlfeld und
 * die Bestellansicht für die Anschrift. Stünde die Liste zweimal da, zeigte die
 * eine „Österreich" und die andere „AT" — und niemandem fiele auf, welche
 * veraltet ist.
 *
 * Der Code geht an den Server, der Name steht auf dem Bildschirm — und der ist
 * ein Textschlüssel und keine Zeichenkette: „Österreich" heißt auf Englisch
 * „Austria", und wer die Seite auf Englisch liest, sucht das auch. Ob der Laden
 * dorthin liefert, entscheidet weiter der Server.
 */
export const LAENDER: { code: string; name: Textschluessel }[] = [
  { code: 'DE', name: 'kasse.landDE' },
  { code: 'AT', name: 'kasse.landAT' },
  { code: 'CH', name: 'kasse.landCH' },
]

/**
 * Der Name eines Landes, oder sein Code.
 *
 * Ein unbekannter Code wird gezeigt und nicht verschluckt: Eine Bestellung aus
 * einem Land, das dieser Laden erst seit gestern beliefert, soll die Anschrift
 * vollständig zeigen — lieber „PL" als eine fehlende Zeile, in der jemand die
 * Auslandssendung übersieht.
 */
export function useLandName(): (code: string) => string {
  const t = useT()
  return (code) => {
    const treffer = LAENDER.find((land) => land.code === code.trim().toUpperCase())
    return treffer ? t(treffer.name) : code
  }
}
